// extracted by mini-css-extract-plugin
export default {"title":"SolutionEffect_title__SRX2D","expertMode":"SolutionEffect_expertMode__bU9Kg"};